<template>
  <ontick-div>
    <!-- #region modal de nova configuração de parâmetros -->
    <modal-setting
      v-if="close"
      :active="close"
      @close="close = false"
    ></modal-setting>
    <!-- #endregion -->

    <!-- #region versões de configurações de parâmetros -->
    <select-setting
      type="setting"
      @create-setting="close = true"
      @change="selectedParam($event)"
    ></select-setting>
    <!-- #endregion -->
  </ontick-div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "add-params-setting",
  components: {
    ModalSetting: () => import("./modal-setting/modal-setting.component"),
    SelectSetting: () => import("./select-setting.component"),
  },
  data() {
    return {
      close: false,
    };
  },
  created() {
    this.getParameterSettings(this.$route.params.investment_id);
  },
  methods: {
    ...mapActions({
      getParameterSettings: "investment/getParameterSettings",
      selectedParam: "investment/selectedParam",
    }),
  },
};
</script>
